module.exports = __webpack_public_path__ + "static/media/overFooter.35eda311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Footer/overFooter.svg
// module id = 1772
// module chunks = 0